import { useTranslation } from 'react-i18next';
import { Props } from '../PackageSelector';
import { PartnerProduct } from '../../../services';

const usePackageSelector = ({ onSelect }: Props) => {
  const { t } = useTranslation('package_selector');

  const onProductSelect = (id: string) => {
    if (onSelect) {
      onSelect(id);
    }
  };

  const price = (product: PartnerProduct): string | undefined => {
    return product.requiresPayment ? String(product.price) : undefined;
  };

  const initialPrice = (product: PartnerProduct): string | undefined => {
    if (!product.requiresPayment) {
      return undefined;
    }

    return product.initialPrice ? String(product.initialPrice) : undefined;
  };

  return {
    t,
    onProductSelect,
    price,
    initialPrice,
  };
};

export default usePackageSelector;
